export interface ProviderCancellation {
  labelId: string;
  operationId: string;
  providerReference: string;
  state:
    | "READY"
    | "PROCESSING"
    | "PENDING"
    | "REJECTED"
    | "UNKNOWN"
    | "CONFIRMED";
  failureReason: string | null;
}

export const providerCancellationText: Record<
  ProviderCancellation["state"],
  string
> = {
  READY: "Provider cancellation queued",
  PROCESSING: "Provider cancellation in progress",
  PENDING: "Provider cancellation pending",
  REJECTED: "Provider cancellation rejected",
  UNKNOWN: "Provider cancellation outcome unknown",
  CONFIRMED: "Provider label void confirmed",
};

export function isProviderCancellationUnresolved(error: unknown): boolean {
  if (!error || typeof error !== "object" || !("response" in error))
    return false;
  const response = error.response;
  if (!response || typeof response !== "object" || !("data" in response))
    return false;
  const data = response.data;
  return (
    !!data &&
    typeof data === "object" &&
    "code" in data &&
    data.code === "PROVIDER_CANCELLATION_UNRESOLVED"
  );
}
